<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/alt-text -->
<div *ngIf="error" class="error-message">Please select file JPEG or PNG</div>
<div class="zone" dragDrop (files)="filesDropped($event)" (error)="onError($event)" id="upload-file-zone">
  <input #input class="none" type="file" (change)="onChange($event)" accept="image/*" />
  <div class="top">
    Drag your profile photo here or
    <span id="upload-btn" (click)="onActive()">upload</span>
    it from your device
  </div>
  <div class="bottom">400x400 for best resolution</div>

  <div class="flex flex-row photo-container" *ngIf="files[0]">
    <img class="photo" id="uploaded_url" [src]="files[0].url" />
    <rx-button class="ml20 red" id="remove-file" buttonId="remove-file-btn" (click)="remove()">Delete</rx-button>
  </div>
</div>
